var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Виконавці :: "+_vm._s(_vm.title))])])],1),_c('Comments',{attrs:{"type":"contractors","id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }